import React from "react";
import Panel from "../../Panel/Panel";
import BookingCustomerInformation from "../customer/BookingCustomerInformation";

export default class BookingGuestSection extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      sign_in_visible: this.props.guest_information && this.props.guest_information.id ? true : false
    }
    this.onChangeMode = this.onChangeMode.bind(this);
    this.onSignInSuccess = this.onSignInSuccess.bind(this);
    this.onSignUpSuccess = this.onSignUpSuccess.bind(this);
    this.onGuestSuccess = this.onGuestSuccess.bind(this);
    this.onToggleSignIn = this.onToggleSignIn.bind(this);
    this.onToggleSignOut = this.onToggleSignOut.bind(this);   
	}

  componentDidUpdate(prevProps) {
    if (prevProps.mode !== null && this.props.mode === null) {
      this.setState({sign_in_visible: false})
    }
  }

	render() {
    return (
      <div className="GuestSection">
        <a id="Guest" name="Guest"></a>
        <Panel name="Guest" 
               expanded={this.props.expanded}
               onExpandCollapse={this.props.onExpandCollapse}
               header={this.renderHeader()}
               body={this.renderBody()}
        />
      </div>
    );
	}

  renderHeader() {
    return (
      <div>
        <span className={"step-number " + (this.props.isComplete ? 'complete' : '')}>{this.props.isComplete ? '✔' : 1}</span>
        <h3>{I18n.t('guest_details')}</h3>
        {
          this.props.expanded
          ?
          null
          :
          this.renderCollapsedDetail()
        }
      </div>
    );
  }

  renderBody() {
    if (this.props.expanded) {
      return (
        <div className="expand-collapse-body">
          <BookingCustomerInformation {...this.props} 
                                      customerForm={this.props.guestSectionCustomerForm}
                                      customerFormName='guestSectionCustomerForm' 
                                      continueButtonText='continue_as_guest'
                                      signInButtonText='sign_in'
                                      signUpButtonText='continue'
                                      onSignInSuccess={this.onSignInSuccess}
                                      onSignUpSuccess={this.onSignUpSuccess}
                                      onGuestSuccess={this.onGuestSuccess} />
          {this.renderContinueButton()}
        </div>
      );
    } 
  }

  renderContinueButton() {
    if (this.props.guest_information && this.props.guest_information.id) {
      return (
        <div className="continue-btn-wrapper">
          <button type="button" 
            className="btn" 
            onClick={this.props.onGoto.bind(this, this.props.form_fields.length ? 'AdditionalInformation' : 'Payment')}>{I18n.t('continue')}
          </button>
        </div>
      );
    }
  }

  renderCollapsedDetail() {
    if (this.props.guest_information && (this.props.guest_information.first_name || this.props.guest_information.last_name || this.props.guest_information.email)) {
      return (
        <div className="collapsed-detail">
          <h5><strong>{this.props.guest_information.first_name} {this.props.guest_information.last_name}</strong></h5> 
          <p>{this.props.guest_information.email}</p>
          <p>{this.props.guest_information.formatted_phone}</p>

          {false && this.props.guest_confirmed != null && !this.props.guest_confirmed && !this.props.guest_information.google_token
          ?
          <div>
            <br/>
            <div className="alert alert-success" style={{marginBottom: 0}}>
              <ul>
                <li>
                  {I18n.t("check_your_inbox_and_confirm_new_email")}
                </li>
              </ul>
            </div>
          </div>
          :
          null
          }
        </div>
      );
    }
  }

  /**
  * Change handlers
  */

  onSignInSuccess() {
    this.props.onGoto(this.props.form_fields.length ? 'AdditionalInformation' : 'Payment')
  }

  onSignUpSuccess() {
    this.props.onGoto(this.props.form_fields.length ? 'AdditionalInformation' : 'Payment')
  }

  onGuestSuccess() {
    this.props.onGoto(this.props.form_fields.length ? 'AdditionalInformation' : 'Payment')
  }

  onChangeMode(mode, e) {
    if (e && e.preventDefault && e.stopPropagation) {
      e.preventDefault()
      e.stopPropagation()
    }

    this.props.onChangeGuestSectionMode(mode);
  }

  onToggleSignIn(e) {
    var self = this;

    if (e && e.preventDefault && e.stopPropagation) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (this.props.mode === null) {
      var mode = 'RETURNING_CUSTOMER'
    } else if (this.props.mode === 'RETURNING_CUSTOMER') {
      var mode = null
    }

    this.setState({sign_in_visible: !this.state.sign_in_visible}, function () {
      self.props.onChangeGuestSectionMode(mode);
    });
  }

  onToggleSignOut(e) {
    var self = this;

    e.preventDefault();

    this.setState({sign_in_visible: false}, function () {
      self.props.onChangeGuestSectionMode(null);
      self.props.onSignOut();
    });
  }

}